import React from 'react'

import {
  GlobalSearchShortcut,
  RelationPicker,
  SimpleClient,
  TopBar,
} from '@bbl-digital/snorre-v2'
import { useAuth } from 'Auth/shared/hooks/useAuth'
import { useAppDispatch, useAppSelector } from 'shared/store/store'
import { useHistory } from 'react-router-dom'
import { getBblSettings, getBblUrls } from 'shared/store/bbl/selectors'
import { setClientById } from 'shared/store/clients/actions'
import { getActiveClient, getClients } from 'shared/store/clients/selectors'
import { getUser } from 'shared/store/user/selectors'
import Notifications from '../../../shared/Notifications'
import User from '../shared/User'

const TopLayoutDesktop: React.FC = () => {
  const authContext = useAuth()

  const { push } = useHistory()

  const dispatch = useAppDispatch()

  const urls = useAppSelector(getBblUrls)
  const settings = useAppSelector(getBblSettings)
  const activeClient = useAppSelector(getActiveClient)
  const clients = useAppSelector(getClients)

  const { data } = useAppSelector(getUser)

  const logout = () => {
    const bbl_redirect = settings?.afterLogoutRedirectUrl || ''
    authContext.signOutRedirect({
      post_logout_redirect_uri: window.location.origin + '/portal/afterlogout',
      bbl_redirect,
    })
  }

  const goToProfile = () => {
    if (!urls?.myPage) return
    window.location.replace(
      `${urls.myPage}${urls.myPage.endsWith('/') ? '' : '/'}profil?returnUrl=${
        window.location.href
      }`
    )
  }

  const handleSetClient = (selected: SimpleClient) => {
    if (!activeClient) return
    if (selected.id === activeClient?.id) return

    dispatch(setClientById(selected.id))

    push('/')
  }

  return (
    <TopBar className="bg-surface-common-background">
      {clients?.length > 1 && (
        <TopBar.Slot>
          <RelationPicker
            withClientNo={true}
            currentClient={{
              id: activeClient?.id,
              name: activeClient?.clientName,
              no: activeClient?.clientNo,
            }}
            clients={clients}
            onSelect={handleSetClient}
          />
        </TopBar.Slot>
      )}
      <TopBar.Slot>
        <GlobalSearchShortcut
          variant="topnav-elevated"
          text="Søk i portalen"
          className="max-w-full shadow-sm"
        />
      </TopBar.Slot>
      <TopBar.Slot className="flex justify-end ">
        <div className="flex items-center gap-sm">
          {data && (
            <User user={data} onLogout={logout} onGoToProfile={goToProfile} />
          )}
          <Notifications />
        </div>
      </TopBar.Slot>
    </TopBar>
  )
}

export default TopLayoutDesktop
